// project import
import applications from './applications';
import cars from './cars';
import contacts from './contacts';
import commerce from './commerce';
import promoove from './promoove';
import events from './events';
import config from './config';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [commerce, contacts, applications, cars, promoove, events, config]
};

export default menuItems;
